
































export default {
	props: {
		options: {
			type: Array,
			required: true,
		},
		value: {
			type: Array,
			required: true
		}
	},

	computed: {
		visible_columns: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	}
}
